import { AuthEffects } from "./store/effects/auth.effects";

export const effectsArr = [AuthEffects];
